// Actions
export const SET_COLUMNS = Symbol('SET_COLUMNS');
export const SET_IS_RESIZING = Symbol('SET_IS_RESIZING');
export const SET_LEFTOVER_COLUMN_WIDTH = Symbol('SET_LEFTOVER_COLUMN_WIDTH');
export const SET_RESET_TO_SCROLL_TOP = Symbol('SET_RESET_TO_SCROLL_TOP');

// Grid virtualization constants
export const BUFFER_COLUMNS = 1;
export const BUFFER_ROWS = 500;
